import { fromJS } from 'immutable';
import {
  TOGGLE_WIDGET,
  TOGGLE_MODAL,
  SET_SUSTAINABILITY_SELECTED,
  SET_INPUT_DATA,
  SET_INPUT_DATA_OFFER,
  SET_CONTRACTUAL_CATEGORY,
  SET_CONTRACTUAL_CATEGORY_OFFER,
  TOGGLE_LOADING,
  GET_LOGIC_RESPONSE,
  GET_LOGIC_OFFER_RESPONSE,
  CHECK_SUSTAINABILITY_RESPONSE,
  CHECK_SUSTAINABILITY_OFFER_RESPONSE,
  RESET_DATA,
  RESET_OFFER_DATA,
} from './constants';

const checkInputDefaultData = {
  contractualCategory: null,
  step: null,
  answers: {}
};

const prescoringStorage = getFromLocalStorage();

// The initial state of forms
export const initialState = fromJS({
  checkInput: {
    contractualCategory: prescoringStorage.contractualCategory || null,
    step: prescoringStorage.step || null,
    answers: prescoringStorage.clientAnswers || {}
  },
  checkResponse: prescoringStorage.checkResponse || {},
  logic: prescoringStorage.logic || [],
  offerSustainability: {
    checkInput: {
      contractualCategory: prescoringStorage.contractualCategory || null,
      step: prescoringStorage.step || null,
      answers: prescoringStorage.clientAnswers || {}
    },
    checkResponse: prescoringStorage.checkResponse || {},
    logic: prescoringStorage.logic || [],
  },
  widgetIsOpen: false,
  modalIsOpen: false,
  sustainabilitySelected: prescoringStorage.checkResponse
                          && typeof prescoringStorage.checkResponse.chance === 'number'
                          ? [prescoringStorage.checkResponse.chance] : [],
  loading: false
});

function offerSelectorReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_WIDGET:
      return state.set('widgetIsOpen', action.isOpen);
    case TOGGLE_MODAL:
      return state.set('modalIsOpen', action.isOpen);
    case SET_SUSTAINABILITY_SELECTED:
      return state.set('sustainabilitySelected', fromJS(action.sustainabilitySelected));
    case SET_CONTRACTUAL_CATEGORY:
      updateLocalStorage({
        contractualCategory: action.contractualCategory,
        step: null,
        clientAnswers: {}
      });

      return state.setIn(['checkInput', 'contractualCategory'], fromJS(action.contractualCategory))
        .setIn(['checkInput', 'step'], null)
        .set('checkResponse', fromJS({}))
        .setIn(['checkInput', 'answers'], fromJS({}));
    case SET_CONTRACTUAL_CATEGORY_OFFER:
      return state.setIn(['offerSustainability', 'checkInput', 'contractualCategory'], fromJS(action.contractualCategory))
        .setIn(['offerSustainability', 'checkInput', 'step'], null)
        .setIn(['offerSustainability', 'checkResponse'], fromJS({}))
        .setIn(['offerSustainability', 'checkInput', 'answers'], fromJS({}));
    case SET_INPUT_DATA:
      updateLocalStorage({
        step: action.inputData.step,
        clientAnswers: {
          ...action.inputData.answers,
        }
      });

      return state.set('checkInput', fromJS(action.inputData))
        .setIn(['offerSustainability', 'checkInput'], fromJS(action.inputData));
    case SET_INPUT_DATA_OFFER:
      return state.setIn(['offerSustainability', 'checkInput'], fromJS(action.inputData));
    case TOGGLE_LOADING:
      return state.set('loading', action.isLoading);
    case GET_LOGIC_RESPONSE:
      updateLocalStorage({
        logic: action.logicData,
        step: action.logicData[0].q
      });

      return state.set('logic', fromJS(action.logicData))
        .setIn(['checkInput', 'step'], action.logicData[0].q)
        .set('loading', false);
    case GET_LOGIC_OFFER_RESPONSE:
      return state.setIn(['offerSustainability', 'logic'], fromJS(action.logicData))
        .setIn(['offerSustainability', 'checkInput', 'step'], action.logicData[0].q)
        .set('loading', false);
    case CHECK_SUSTAINABILITY_RESPONSE:
      updateLocalStorage({
        checkResponse: action.responseData,
        step: action.responseData.currentStep
      });

      const responseChance = action.responseData.chance;
      let sustainabilitySelected = state.get('sustainabilitySelected');

      if (typeof responseChance === 'number') {
        sustainabilitySelected = fromJS([responseChance]);
      }

      return state.set('checkResponse', action.responseData)
        .setIn(['checkInput', 'step'], action.responseData.currentStep)
        .set('sustainabilitySelected', sustainabilitySelected)
        .setIn(['offerSustainability', 'checkResponse'], action.responseData)
        .setIn(['offerSustainability', 'checkInput', 'step'], action.responseData.currentStep)
        .set('loading', false);
    case CHECK_SUSTAINABILITY_OFFER_RESPONSE:
      return state.setIn(['offerSustainability', 'checkResponse'], action.responseData)
        .setIn(['offerSustainability', 'checkInput', 'step'], action.responseData.currentStep);
    case RESET_DATA:
      localStorage.removeItem('prescoring')
      return state.set('checkInput', fromJS(checkInputDefaultData))
        .set('checkResponse', fromJS({}))
        .set('sustainabilitySelected', fromJS([]))
        .set('logic', fromJS([]))
        .set('loading', false);
    case RESET_OFFER_DATA:
      return state.setIn(['offerSustainability', 'checkInput'], fromJS(checkInputDefaultData))
        .setIn(['offerSustainability', 'checkResponse'], fromJS({}))
        .setIn(['offerSustainability', 'logic'], fromJS([]))
        .set('loading', false);
    default:
      return state;
  }
}

function updateLocalStorage(data) {
  let storageData = JSON.parse(localStorage.getItem('prescoring'));
  const now = new Date();

  storageData = {
    ...storageData,
    ...data,
    expiry: now.getTime() + (3600 * 1000)
  };

  localStorage.setItem('prescoring', JSON.stringify(storageData))
}

function getFromLocalStorage() {
  const itemStr = localStorage.getItem('prescoring');

	if (!itemStr) {
		return {};
	}

	const item = JSON.parse(itemStr);
	const now = new Date();

	if (now.getTime() > item.expiry) {
		localStorage.removeItem('prescoring');
		return {};
	}

  updateLocalStorage({});

	return item;
}

export default offerSelectorReducer;
